import { toast } from 'react-toastify'

import API from "../../api";
import { getDay } from "../../functions";
import { queryClient } from "../../react-query"
import { useHubAgenda } from "../../../store/hub/useHubAgenda";
import { formatResponses } from '../../formatResponses/hub';

export class HubAgendaModel {
  hubAction = useHubAgenda.getState().actions

  async details(date) {
    const requestDate = getDay(date).format('YYYY-MM-DD')

    try {
      const result = await queryClient.ensureQueryData({
        queryKey: ['hub', 'agenda-details', requestDate],
        queryFn: async () => await API.get(`/hub/appointments-details?date=${requestDate}`)
      })

      this.hubAction.setDetails(requestDate, result.data)

      return result
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível carregar os detalhes da agenda', { theme: 'colored' })
      return false
    }
  }
  async heatMap(date) {
    const requestDate = getDay(date).format('YYYY-MM-DD')

    try {
      const result = await queryClient.ensureQueryData({
        queryKey: ['hub', 'agenda-heatmap', requestDate],
        queryFn: async () => await API.get(`/hub/free-time?date=${requestDate}`),

      })


      const formattedHeatMap = formatResponses.heatMap(result.data);

      this.hubAction.setHours(formattedHeatMap[requestDate].hours)
      this.hubAction.setHeatMap(requestDate, formattedHeatMap[requestDate])


      return result
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível carregar os detalhes da agenda', { theme: 'colored' })
      return false
    }
  }

}
